import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";
import { ExternalLink, Star } from "lucide-react";

const daysSince = (iso) => (iso ? Math.floor((Date.now() - new Date(iso).getTime()) / 86400000) : null);

export const ReviewSourceColumn = ({ source, meta, items, onOpen, onReplied, canEdit }) => {
  const url = meta?.links?.[source];
  const approved = meta?.status?.[source] === "approved";
  const d = daysSince(meta?.checks?.[source]);
  const latest = items.filter((i) => i.source === source).slice(0, 10);
  const open = latest.filter((i) => !i.replied).length;
  return (
    <Card className="flex flex-col rounded-none border" data-testid={`review-src-${source}`}>
      <div className="flex items-center justify-between gap-2 border-b border-border p-3">
        <div>
          <div className="text-sm font-bold">{source}</div>
          <div className={`text-[0.65rem] ${d === null || d >= 7 ? "font-semibold text-amber-600" : "text-muted-foreground"}`}>
            {d === null ? "Never checked" : d === 0 ? "Checked today" : `Checked ${d}d ago`}{open ? ` · ${open} not replied` : ""}
          </div>
        </div>
        <Button size="sm" variant="outline" className="h-7" disabled={!url} onClick={() => onOpen(source, url)} data-testid={`review-open-${source}`}
          title={url ? (approved ? "Open review page" : "Search link — awaiting Admin approval") : "No link set (Property → Review Site Links)"}>
          <ExternalLink className="mr-1 h-3.5 w-3.5" /> {url ? (approved ? "Open" : "Open*") : "No link"}
        </Button>
      </div>
      <div className="flex-1 divide-y divide-border">
        {latest.length === 0 && <div className="p-3 text-xs text-muted-foreground">No reviews logged.</div>}
        {latest.map((r) => (
          <div key={r.id} className={`flex items-start gap-2 px-3 py-1.5 text-xs ${r.replied ? "" : "bg-amber-500/5"}`} data-testid={`review-line-${r.id}`}>
            <div className="min-w-0 flex-1 truncate" title={r.comment}>
              <span className="font-semibold">{r.guest_name || "Guest"}</span>
              {r.rating && <span className="ml-1 inline-flex items-center gap-0.5 text-primary"><Star className="h-3 w-3" />{r.rating}</span>}
              <span className="ml-1 text-muted-foreground">— {r.comment}</span>
            </div>
            <label className="flex shrink-0 cursor-pointer items-center gap-1 text-[0.65rem]" title={r.replied_by ? `Replied · ${r.replied_by}` : ""}>
              <Checkbox checked={!!r.replied} disabled={!canEdit} onCheckedChange={(v) => onReplied(r, !!v)} data-testid={`review-replied-${r.id}`} />
              <span className={r.replied ? "text-emerald-600" : "text-amber-700"}>{r.replied ? "Replied" : "Reply"}</span>
            </label>
          </div>
        ))}
      </div>
    </Card>
  );
};
